import React from "react";
import {
  View,
  Text,
  StyleSheet,
  Image,
  TouchableOpacity,
  ImageSourcePropType,
  ImageBackground,
} from "react-native";
import { useTranslation } from "react-i18next";
import { buyNowChips, ChipsBackgrOneLand } from "../../../../assets";
import { Package } from "../../../../store/types";

type VipCardProps = {
  vipIcon: ImageSourcePropType;
  borderColor: string;
  textColor: string;
  vipLabel: ImageSourcePropType;
  chipBackground: ImageSourcePropType;
  amount: number;
  price: number;
  pkg: Package;
  onPayment: (packageItem: Package) => void; // parent decides web/native flow
};

const ChipCard = ({
  vipIcon,
  textColor,
  vipLabel,
  amount,
  price,
  pkg,
  onPayment,
}: VipCardProps) => {
  const { t } = useTranslation();
  const handleBuyPress = () => {
    onPayment(pkg); // ✅ this will be handleBuyPress from BuyPackagesModal
  };

  return (
    <ImageBackground
      source={ChipsBackgrOneLand}
      resizeMode="stretch"
      style={styles.background}
    >
      <View style={styles.card}>
        <View style={styles.left}>
          <Image
            source={vipIcon}
            style={styles.vipImage}
            resizeMode="contain"
          />
        </View>

        <View style={styles.right}>
          <View style={styles.labelRow}>
            <Image
              source={vipLabel}
              style={styles.vipLabel}
              resizeMode="contain"
            />
            <Text
              style={[
                styles.month,
                {
                  color: textColor,
                  textShadowColor: "#000",
                  textShadowOffset: { width: 1, height: 2 },
                  textShadowRadius: 2,
                  letterSpacing: 0.5,
                },
              ]}
            >
              {amount}
            </Text>
          </View>

          <Text style={styles.price}>{price}€</Text>

          <TouchableOpacity
            style={styles.buyNowButton}
            onPress={handleBuyPress}
          >
            <ImageBackground
              source={buyNowChips}
              style={styles.buyNowBtn}
              resizeMode="contain"
            >
              <Text style={styles.text}>{t("T_SITE_HEADER_BUY")}</Text>
            </ImageBackground>
          </TouchableOpacity>
        </View>
      </View>
    </ImageBackground>
  );
};

export default ChipCard;

const styles = StyleSheet.create({
  background: {
    width: "100%",
    textAlign: "center",
    margin: "auto",
  },
  card: {
    flexDirection: "row",
    alignItems: "center",
  },
  left: {
    flex: 1,
    alignItems: "center",
  },
  right: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    paddingLeft: 12,
  },
  labelRow: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 8,
  },
  vipImage: {
    width: 200,
    height: 160,
  },
  vipLabel: {
    width: 30,
    height: 24,
  },
  month: {
    fontSize: 20,
    fontWeight: "900",
    marginLeft: 8,
  },
  price: {
    fontSize: 20,
    fontWeight: "500",
    color: "#fff",
    textAlign: "center",
    marginVertical: 12,
    textShadowColor: "#000",
    textShadowOffset: { width: 1, height: 1 },
    textShadowRadius: 2,
    letterSpacing: 1,
    textTransform: "uppercase",
  },
  buyNowButton: {
    borderRadius: 6,
    paddingBottom: 10,
  },
  buyNowBtn: {
    width: 110,
    height: 36,
  },
  text: {
    fontSize: 15,
    fontWeight: "700",
    letterSpacing: 0.6,
    color: "#E0E0E0",
    textShadowColor: "rgba(0, 0, 0, 0.6)",
    textShadowOffset: { width: 0, height: 2 },
    textShadowRadius: 2,
    textTransform: "uppercase",
    textAlign: "center",
    paddingTop: 6,
  },
});
